import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"
import { query } from "lib/graphql/query"
import { invalidate } from "lib/graphql/cache"

export const publishPlan = api(function publishPlan(planId, type = "publish", revisionSummary) {
    return mutate(
        gql`
            mutation PublishPlan($planId: String!, $type: String!, $revisionSummary: String) {
                publishPlan(id: $planId, type: $type, revisionSummary: $revisionSummary)
            }
        `,
        { planId, type, revisionSummary },
        { returns: "publishPlan" }
    ).then((result) => {
        invalidate("regimeDifferences")
        return result
    })
})

export const getPublishedPlan = api(function getPublishedPlan(id, type = "publish") {
    if (!id) return null
    return query(
        gql`
            query GetPublishedPlan($id: String!, $type: String!) {
                getPublishedPlan(id: $id, type: $type)
            }
        `,
        { id, type },
        { returns: "getPublishedPlan" }
    )
})

export const getHistoricalPlan = api(function getHistoricalPlan(historyId) {
    return query(
        gql`
            query GetHistoricalPlan($historyId: String!) {
                getHistoricalPlan(historyId: $historyId)
            }
        `,
        {
            historyId,
        },
        { returns: "getHistoricalPlan" }
    )
})

export const removePlan = api(function removePlan(id, type = "publish") {
    return mutate(
        gql`
            mutation RemovePlan($id: String!, $type: String!) {
                removePlan(id: $id, type: $type)
            }
        `,
        { id, type },
        { returns: "removePlan" }
    )
})

export const rejectPlan = api(function rejectPlan(id, type = "publish", rejectionSummary) {
    return mutate(
        gql`
            mutation RejectPlan($id: String!, $type: String, $rejectionSummary: String) {
                rejectPlan(id: $id, type: $type, rejectionSummary: $rejectionSummary)
            }
        `,
        { id, type, rejectionSummary },
        { returns: "rejectPlan" }
    )
})
